<div class="flex flex-wrap mt-8 mb-6">

    @let user = (user$ | async);
    @let grade = (grade$ | async);
    @let group = (group$ | async);

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo=".." [queryParams]="{ academicYear: academicYear }"></app-btn-back>
        @if (group?.memberStatus == membershipStatus.active && gradeLesson?.academicYear == group?.academicYear
        &&
        (((myRoles$ | async)?.management) || (facultyId == user?.uid && grade?.teacherId == user?.uid))) {
        <app-btn-route routeTo="addnotes" colors="bg-primary-500 hover:bg-primary-300" textColor="text-white"
            icon="fa fa-add" btnText="Add Notes"></app-btn-route>
        }
    </div>

    <div class="flex flex-row justify-between mb-4 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">
            {{ gradeLesson?.lessonName }}
        </h1>
        <!-- <button class="btn btn-primary btn-sm" (click)="print()">
            <i class="fas fa-print"></i>
        </button> -->
    </div>


    <div class="flex flex-col mb-4 border-0 w-full">

        @if ((gradeLesson?.teacherNotes?.length || 0) > 0) {
        <label class="block uppercase text-blueGray-600 text-xs font-bold mt-4 mb-2">
            Teacher Notes
        </label>
        }

        @for (item of gradeLesson?.teacherNotes; track $index) {

        <div class="bg-white shadow-lg rounded w-full px-4 py-3 mb-4">
            <div class="cursor-default flex flex-col gap-1">
                <div class="flex flex-row items-start justify-between w-full mb-1">
                    <div class="flex flex-row justify-start gap-4">
                        @if(item.type == noteTypes.pdf) {
                        <a [href]="item.url || null" class="flex flex-col justify-start"
                            [attr.target]="item.url ? '_blank' : null"
                            [attr.rel]="item.url ? 'noopener noreferrer' : null">
                            <div class="flex flex-row justify-start">
                                <div
                                    [class]="item.url ? 'text-blue-500 hover:underline' : 'text-gray-400 cursor-not-allowed'">
                                    <i class="far fa-file-pdf text-lg"></i>
                                </div>
                                <ng-container *ngTemplateOutlet="sharedContent"></ng-container>
                            </div>
                        </a>
                        } @else if(item.type == noteTypes.text) {
                        <a [routerLink]="['notes', item.id]">
                            <div class="flex flex-row justify-start">
                                <div
                                    [class]="item.url ? 'text-blue-500 hover:underline' : 'text-gray-400 cursor-not-allowed'">
                                    <i class="far fa-file-lines text-lg"></i>
                                </div>
                                <ng-container *ngTemplateOutlet="sharedContent"></ng-container>
                            </div>
                        </a>
                        }
                        <ng-template #sharedContent>
                            <div class="flex flex-col justify-start ml-4">
                                <p class="text-primary-300 text-xs whitespace-nowrap">
                                    {{ item.created | moment: 'Do MMM YYYY' }}
                                </p>
                                <p class="font-semibold mr-1">
                                    {{ item.name }}
                                </p>
                            </div>
                        </ng-template>
                    </div>
                    @if(gradeLesson?.academicYear == group?.academicYear && ((myRoles$ | async)?.management ||
                    ((myRoles$ | async)?.faculty && item.createdById ==
                    user?.uid))) {
                    <div class="flex flex-row gap-2 whitespace-nowrap">
                        <app-btn-fab (click)="onEditNotes(item)" icon="fas fa-edit" tooltip="Edit Notes"></app-btn-fab>
                        <app-btn-fab (click)="onDelete(item.id)" icon="fa fa-trash-can"
                            textColor="text-red-500 disabled:text-gray-200" tooltip="Delete"></app-btn-fab>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

        @if(gradeLesson?.notesUrl) {
        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
            Lesson
        </label>
        @if(gradeLesson?.notesType == noteTypes.pdf) {
        <div class="bg-white rounded px-4 py-2 flex flex-row justify-start gap-4">
            <a [href]="gradeLesson?.notesUrl || null" class="flex flex-col justify-start"
                [attr.target]="gradeLesson?.notesUrl ? '_blank' : null"
                [attr.rel]="gradeLesson?.notesUrl ? 'noopener noreferrer' : null">

                <div class="flex flex-row justify-start">
                    <div
                        [class]="gradeLesson?.notesUrl ? 'text-blue-500 hover:underline' : 'text-gray-400 cursor-not-allowed'">
                        <i class="far fa-file-pdf text-lg"></i>
                    </div>
                    <div class="flex flex-col justify-start ml-4">
                        <p class="text-primary-300 text-xs whitespace-nowrap">
                            {{ gradeLesson?.created | moment: 'Do MMM YYYY' }}
                        </p>
                        <p class="font-semibold mr-1">
                            {{ gradeLesson?.lessonName }}
                        </p>
                    </div>
                </div>

            </a>
        </div>
        } @else {
        <div class="rounded-t block w-full overflow-x-auto overflow-y-auto shadow-lg rounded bg-white">
            <rich-text-editor [jsonFormat]="htmlData" [isEditable]="false" class="w-full"></rich-text-editor>
        </div>
        }
        }
    </div>